import { render, staticRenderFns } from "./Vattenfall.vue?vue&type=template&id=19779247"
import script from "./Vattenfall.vue?vue&type=script&lang=js"
export * from "./Vattenfall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports